import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-header" }
const _hoisted_2 = { class: "header-left" }
const _hoisted_3 = { class: "mb-0" }
const _hoisted_4 = { class: "general-details-row" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h5", { class: "mt-0" }, "Detalii generale", -1)
const _hoisted_6 = { class: "left-content" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { class: "app-inner-container" }
const _hoisted_9 = { class: "details-container xl:flex-row flex-column" }
const _hoisted_10 = { class: "right-content" }
const _hoisted_11 = { class: "card-container" }

import { DateUtils } from '@/utils/DateUtils';
import { Doctor } from '@/interfaces/Doctor';
import DoctorService from '@/services/DoctorService';
import DoctorEntity from '@/components/DoctorEntity.vue';
import PayoutHistoryList from '@/components/PayoutHistoryList.vue';
import { computed, onMounted, ref, Ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import Button from 'primevue/button';
import ConfirmDialog from 'primevue/confirmdialog';
import Toast from 'primevue/toast';
import { useConfirm } from 'primevue/useconfirm';
import { useToast } from 'primevue/usetoast';
import { DoctorConfig as DoctorConfiguration } from '@/interfaces/DoctorConfig';
import { PayoutInfo } from '@/interfaces/PayoutInfo';
import PayoutService from '@/services/PayoutService';
import Card from 'primevue/card';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import { DoctorPayoutInfo } from '@/interfaces/DoctorPayoutInfo';


export default /*#__PURE__*/_defineComponent({
  __name: 'PayoutDetailsView',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const confirm = useConfirm();
const toast = useToast();
const doctorId = route.params.id as string;

const showDoctorDetails = ref(false);
const doctor: Ref<Doctor | null> = ref(null as Doctor | null);
const config: Ref<DoctorConfiguration | null> = ref(null as DoctorConfiguration | null);
const payouts: Ref<PayoutInfo[]> = ref([] as PayoutInfo[]);
const ongoingPayouts: Ref<PayoutInfo[]> = ref([] as PayoutInfo[]);
const latestPayout: Ref<PayoutInfo | null> = ref(null as PayoutInfo | null);
const payoutInfo: Ref<DoctorPayoutInfo | null> = ref(null as DoctorPayoutInfo | null);

const activeTab = ref(1);

const onTabChange = (event: { index: number }) => {
  activeTab.value = event.index;
  if (event.index === 0) {
    router.replace({ path: '/payouts' });
  }
};

const toggleDetails = () => {
  showDoctorDetails.value = !showDoctorDetails.value;
};

const latestPayoutInTheFuture = computed(() => {
  if (latestPayout.value && latestPayout.value?.runDate) {
    return DateUtils.isInThePast(latestPayout.value?.runDate);
  }
  return false;
});

const isValidForm = ref(true);
const safeDisplay = (value: string): string => value || '';

const payoutsim = computed(() => (payoutInfo.value ? [payoutInfo] : []));

const callPayout = () => {
  confirm.require({
    message: 'Suneti sigur ca doriti sa initiati o decontare?',
    header: 'Confirmare',
    icon: 'pi pi-exclamation-triangle',
    acceptLabel: 'Da',
    rejectLabel: 'Nu',
    accept: async () => {
      try {
        const savedPayout = await PayoutService.triggerPayoutForDoctor(doctorId);
        if (savedPayout && savedPayout.id) {
          showSuccess('Procesul de decontare manuala a fost initiat');
          setTimeout(() => {
            location.reload();
          }, 1000);
        } else {
          showError('Nu s-a putut initia procesul de decontare manuala');
        }
      } catch {
        showError('Nu s-a putut initia procesul de decontare manuala');
      }
    }
  });
};

const showError = (message: string) => {
  toast.add({ severity: 'error', summary: 'A aparut o eroare!', detail: message, life: 3000 });
};

const showSuccess = (message: string) => {
  toast.add({ severity: 'success', summary: 'Actiune realizata cu succes!', detail: message, life: 3000 });
};

async function loadPayouts(doctorId: string) {
  const [payoutHistory, latestPayout] = await Promise.all([
    PayoutService.fetchPayoutHistory(doctorId),
    PayoutService.fetchLatestPayout(doctorId)
  ]);

  if (payoutHistory) {
    payoutHistory.forEach((p) => (p.grouping = 'DONE'));
    payouts.value = [...payoutHistory];
  }

  if (latestPayout && latestPayout.status !== 'DONE') {
    latestPayout.grouping = 'A_PENDING';
    if (!payouts.value) payouts.value = [];
    payouts.value.push(latestPayout);
  }
}

onMounted(async () => {
  try {
    const fetchedDoctor = await DoctorService.fetchDoctor(doctorId);
    if (fetchedDoctor) {
      doctor.value = fetchedDoctor;
      if (doctor.value) {
        const fetchedConfig = await DoctorService.fetchDoctorConfig(doctorId);
        if (fetchedConfig) {
          fetchedConfig.commissionPercent *= 100;
          config.value = fetchedConfig;
          doctor.value.config = config.value;
        }
        payoutInfo.value = await PayoutService.fetchPayoutInfoForDoctor(doctorId);
        ongoingPayouts.value = await PayoutService.fetchOngoingPayout(doctorId);
        loadPayouts(doctorId);
      }
    }
  } catch (error) {
    console.log(error);
  }
});

const goToPayouts = () => {
  router.push('/payouts');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Toast)),
    _createVNode(_unref(ConfirmDialog)),
    _createVNode(_unref(Card), null, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h1", _hoisted_3, _toDisplayString(safeDisplay(doctor.value?.title!) + ' ' + safeDisplay(doctor.value?.firstName!) + ' ' + safeDisplay(doctor.value?.lastName!)), 1),
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("button", {
                class: "expand-btn",
                onClick: toggleDetails
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(showDoctorDetails.value ? 'pi pi-times' : 'pi pi-bars')
                }, null, 2)
              ])
            ])
          ])
        ])
      ]),
      content: _withCtx(() => [
        _createVNode(_unref(TabView), {
          activeIndex: activeTab.value,
          onTabChange: onTabChange
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(TabPanel), {
              header: "Decontări",
              onClick: goToPayouts
            }),
            _createVNode(_unref(TabPanel), { header: "Conținut" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  (showDoctorDetails.value)
                    ? (_openBlock(), _createBlock(DoctorEntity, {
                        key: 0,
                        doctor: doctor.value
                      }, null, 8, ["doctor"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  _hoisted_7
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(PayoutHistoryList, {
                          payouts: payouts.value,
                          payoutsongoing: ongoingPayouts.value,
                          payoutsim: [payoutInfo.value!]
                        }, null, 8, ["payouts", "payoutsongoing", "payoutsim"])
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["activeIndex"])
      ]),
      _: 1
    })
  ], 64))
}
}

})